import {
  networkErrorAlert,
  clearNetworkErrorAlert,
} from "../actions/networkActions";

export default {
  showErrorAlert: (dispatch, error) => {
    dispatch(networkErrorAlert(error));
  },
  clearServerErrorAlert: dispatch => {
    dispatch(clearNetworkErrorAlert("serverError"));
  },
  clearFreeswitchErrorAlert: dispatch => {
    dispatch(clearNetworkErrorAlert("freeswitchError"));
  },
};






// WEBPACK FOOTER //
// ./src/services/networkService.js